import styled from 'styled-components';
import { Styling } from '../../../../../constants';

export const Container = styled.div`
  display: flex;
  flex-shrink: 0;
`;

export const Pane = styled.div`
  display: flex;
  align-items: center;
  margin: 0 ${Styling.DEFAULT_SPACING}px;
  span {
    display: inline-block;
  }
`;
